import { Paragraph, Select, tokens } from '@welbe/web-design-system';
import React, { useContext } from 'react';
import { Container } from './ExpositionLevel.styles';
import { JobProfileContext } from 'Views/JobProfile/JobProfile.context';
import {
	ExpositionFrequencyEnum,
	ExpositionLevelEnum,
} from './ExpositionLevel.const';

export const ExpositionLevel = () => {
	const { jobRiskFactors, focusedId, setJobRiskFactors } =
		useContext(JobProfileContext);

	const index = jobRiskFactors.findIndex(
		(item) => item.jobProfileRiskFactor.id === focusedId,
	);

	const handleSelect = (
		field: 'exposureLevel' | 'frequency',
		value: string,
	) => {
		const hasElement = jobRiskFactors[index]?.jobProfileRiskFactor;

		if (hasElement) {
			jobRiskFactors[index].jobProfileRiskFactor[field] = value || '';
			setJobRiskFactors([...jobRiskFactors]);
		}
	};

	const initialExposition =
		ExpositionLevelEnum.find(
			(item) =>
				item.id === jobRiskFactors[index]?.jobProfileRiskFactor?.exposureLevel,
		) || ExpositionLevelEnum[0];

	const initialFrequency =
		ExpositionFrequencyEnum.find(
			(item) =>
				item.id === jobRiskFactors[index]?.jobProfileRiskFactor?.frequency,
		) || ExpositionFrequencyEnum[0];

	return (
		<div>
			<Paragraph
				fontSize="18px"
				fontWeight="400"
				color={tokens.color_primary}
				padding="0px 0px 15px 0px"
			>
				Exposición
			</Paragraph>
			<Container>
				<Select
					id="exposureLevel"
					label="Nivel de exposición"
					options={ExpositionLevelEnum}
					initialSelected={initialExposition}
					onChange={(selected) => handleSelect('exposureLevel', selected.id)}
				/>
				<Select
					id="frequency"
					label="Frecuencia"
					options={ExpositionFrequencyEnum}
					initialSelected={initialFrequency}
					onChange={(selected) => handleSelect('frequency', selected.id)}
				/>
			</Container>
		</div>
	);
};
